function codegenNativeCommands(param) {
  var { supportedCommands } = param;
  return Object.fromEntries(supportedCommands.map(function(name) {
    return [
      name,
      function() {
      }
    ];
  }));
}
export {
  codegenNativeCommands as default
};
//# sourceMappingURL=codegenNativeCommands.js.map
